'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

var _swapOutButton = require('./swap-out-button');

var _swapOutButton2 = _interopRequireDefault(_swapOutButton);

var _buttonTextSubmit = require('./button-text-submit');

var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_button2['default'], {
    buttonText: 'EMAIL ME THE LINK',
    buttonClass: 'm-sign-mobile--send',
    buttonColor: 'grasshopper'
});

var _ref2 = _jsx(_button2['default'], {
    buttonText: 'SEND',
    buttonColor: 'grasshopper'
});

var MobileLinkSubmit = _react2['default'].createClass({
    displayName: 'MobileLinkSubmit',


    propTypes: {},

    render: function render() {
        var initialBtn = _ref;

        var submitUrl = _hfReactHelper2['default'].urlHelper('info/sendDownloadLink', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
        var actionBtn = _ref2;
        var validateFunc = function validateFunc(val) {
            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
                return 'Invalid email address.';
            } else {
                return false;
            }
        };
        var swapInChildren = _jsx(_buttonTextSubmit2['default'], {
            actionButton: actionBtn,
            textPlaceholder: 'Enter email address',
            inputName: 'email',
            textClass: 'm-sign-mobile--text-field',
            url: submitUrl,
            divClass: 'm-sign-mobile--send',
            formName: 'mobileLinkFrm',
            validate: validateFunc
        });
        return _jsx(_swapOutButton2['default'], {
            initialButton: initialBtn,
            swapInChildren: swapInChildren
        });
    }

});
module.exports = MobileLinkSubmit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/mobile-link-submit.jsx
 ** module id = 618
 ** module chunks = 0
 **/